import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GetResponseMessengerBot } from '../../models/messenger-bot.interface';
import { UpdateAttentionSchedulePayload } from '../../models/attention-schedule.interface';

@Injectable({
  providedIn: 'root',
})
export class MessengerBotService {
  apiAddress: string = environment.apiAddress;

  constructor(private http: HttpClient) {}

  postPageSubscription(
    botId: string,
    page_id: number,
    is_enabled: boolean,
    page_name: string,
    categories: [string],
    page_access_token: string
  ) {
    return this.http.post<any>(`${this.apiAddress}/bot/${botId}/messenger_bot`, {
      page_id,
      is_enabled,
      page_name,
      categories,
      page_access_token,
    });
  }

  updatePageSubscription(botId: string, is_enabled: boolean) {
    return this.http.put<any>(`${this.apiAddress}/bot/${botId}/messenger_bot`, { is_enabled });
  }

  updateAttentionSchedule(botId: string, payload: UpdateAttentionSchedulePayload) {
    return this.http.put<any>(`${this.apiAddress}/bot/${botId}/messenger_bot`, payload);
  }

  getBotMessenger(botId: string) {
    return this.http.get<GetResponseMessengerBot>(`${this.apiAddress}/bot/${botId}/messenger_bot`);
  }

  deleteBotMessenger(botId: string) {
    return this.http.delete<any>(`${this.apiAddress}/bot/${botId}/messenger_bot`);
  }
}
